// @flow
import { getBaseUrl, getClassicBaseUrl } from '../../../redux/modules/config';
import { openFeedbackModal, openHealthcheckModal } from '../../../redux/modules/modal';
import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getMobileBrowserOS } from '../../../redux/modules/browser';
import { getWindowSize } from '../../../redux/modules/windowSize';
import LAFooter from './LAFooter';

type OwnProps = {||};

const mapStateToProps = state => {
    const { width: windowWidth } = getWindowSize(state);

    return {
        baseUrl: getBaseUrl(state),
        classicBaseUrl: getClassicBaseUrl(state),
        mobileBrowserOS: getMobileBrowserOS(state),
        windowWidth,
        year: new Date().getFullYear(),
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            openFeedbackModal,
            openHealthcheckModal,
        },
        dispatch
    );

type ReduxProps = {|
    baseUrl: string,
    classicBaseUrl: string,
    mobileBrowserOS: string,
    windowWidth: number,
    year: number,
|};

type ReduxActions = {|
    openFeedbackModal: typeof openFeedbackModal,
    openHealthcheckModal: typeof openHealthcheckModal,
|};

type Props = {|
    ...OwnProps,
    ...ReduxProps,
    ...ReduxActions,
|};

class LAFooterContainer extends PureComponent<Props> {
    render() {
        const { baseUrl, classicBaseUrl, mobileBrowserOS, windowWidth, year } = this.props;

        return (
            <LAFooter
                baseUrl={baseUrl}
                classicBaseUrl={classicBaseUrl}
                mobileBrowserOS={mobileBrowserOS}
                openFeedbackModal={this.props.openFeedbackModal}
                openHealthcheckModal={this.props.openHealthcheckModal}
                windowWidth={windowWidth}
                year={year}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LAFooterContainer);
